
import "./ShimmerLoading.css";

const ShimmerLoadingTwo = () => {
  return (
    <div className="shimmer-container">
      <div className="shimmer-card"></div>
      <div className="shimmer-card-1"></div>
      <div className="shimmer-card-1"></div>
    </div>
  );
};

export default ShimmerLoadingTwo;
